import React from "react";
import NavBtn from "../NavBtn";
import { FaBoxesPacking } from "react-icons/fa6";

const Inventory = (props) => {
  const {
    exactPath = "/dashboard/inventory",
    to = "/dashboard/inventory",
    partialPath = "/inventory",
    label = "Inventory",
  } = props;

  return (
    <NavBtn
      label={label}
      exactPath={exactPath}
      partialPath={partialPath}
      to={to}
      Icon={FaBoxesPacking}
    />
  );
};

export default Inventory;